import { PermissionEnum } from '@creditsights/api-ui-web';
import { Button, ButtonMode, Loader, Modal, ModalWidth } from '@creditsights/styleguide-web';
import React, { useCallback, useMemo } from 'react';
import {
  useSaveTranslationConsentUserAcknowledge,
  useTranslationConsentContent,
  useTranslationConsentUserAcknowledge,
} from '../../../hooks/consent/translationConsent';
import useFetchUserPermissions from '../../../hooks/permissions/useFetchUserPermissions';
import styles from './UserConsent.module.scss';

const empty = () => {};

const UserConsent = (): React.ReactElement | null => {
  const { data: userPermissions } = useFetchUserPermissions();
  const { mutateAsync, isLoading: isSaving } = useSaveTranslationConsentUserAcknowledge();
  const isAvailable = useMemo(() => !!userPermissions?.includes(PermissionEnum.TRANSLATION), [userPermissions]);

  const { data: userAcknowledge, isLoading: isLoadingUserAcknowledge } =
    useTranslationConsentUserAcknowledge(isAvailable);
  const showModal = userAcknowledge?.consent === null && isAvailable;

  const { data: content, isLoading: isLoadingContent } = useTranslationConsentContent(showModal);

  const confirm = useCallback(async () => {
    await mutateAsync({
      configurationId: userAcknowledge?.configuration?.id!,
      consent: {
        message: 'Accepted consent thru v1 website',
        language: 'english',
        expired: false,
      },
    });
  }, [userAcknowledge, mutateAsync]);

  if (!showModal) {
    return null;
  }

  return (
    <Modal
      className={styles.modal}
      onClose={empty}
      open
      headerTitle="Important Translation Notice"
      width={ModalWidth.Medium}
    >
      <div>
        <div dangerouslySetInnerHTML={{ __html: content?.body || '' }} />
        {isLoadingContent ? (
          <Loader position="center" />
        ) : (
          <div className={styles.buttons}>
            <Button mode={ButtonMode.PRIMARY} loading={isSaving || isLoadingUserAcknowledge} onClick={confirm}>
              I Acknowledge
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default UserConsent;
